import { render, staticRenderFns } from "./LmFormPortalBuilderUi.vue?vue&type=template&id=59283c2e&"
import script from "./LmFormPortalBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmFormPortalBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports